import { BrandConfig } from '../../types/config.types';

export const budzdorovConfig: BrandConfig = {
    // ============================================
    // ОСНОВНАЯ ИНФОРМАЦИЯ
    // ============================================
    id: 'budzdorov',
    name: 'Будь Здоров',
    description: 'AI Медицинский Помощник',

    // ============================================
    // API И BACKEND
    // ============================================
    apiUrl: 'https://lazydoc-api.bzklinika.ru',
    defaultPrompt: 'LD-App-Base',

    // ======================= =====================
    // ЛОГОТИПЫ
    // ============================================
    logos: {
        small: 'bz/logos/small-logo.svg', // 32x32px для закрытого сайдбара
        full: 'bz/logos/full-logo.svg', // 160x24px для открытого сайдбара
        auth: 'bz/logos/full-logo.svg', // 200x30px для страницы авторизации
        favicon: 'bz/favicon.ico',
    },

    // ============================================
    // АНИМАЦИИ
    // ============================================
    animations: {
        splashScreen: 'start-bz.json', // Lottie анимация для сплэш-скрина
    },

    // ============================================
    // ТЕМА
    // ============================================
    theme: {
        /**
         * Цветовая схема синхронизирована с текущими SCSS-переменными,
         * чтобы Budzdorov выглядел точно так же, как сейчас:
         * см. src/features/styles/colors-default.scss
         *
         * $primary-color:   #1e6fff;
         * $secondary-color: #e9f0ff;
         * $background-color:#f4f8ff;
         * $text-color:      #222222;
         */
        primary: '#1E6FFF',
        secondary: '#E9F0FF',
        accent: '#FF4757',
        background: '#F4F8FF',
        text: '#222222',
        messageBackground: '#D1E7FF', // фон сообщения пользователя в чате
        cssVariables: {
            '--budzdorov-primary': '#1E6FFF',
            '--budzdorov-secondary': '#E9F0FF',
            '--budzdorov-accent': '#FF4757',
        },
    },

    // ============================================
    // PWA МАНИФЕСТ
    // ============================================
    manifest: {
        name: 'Будь Здоров - AI Медицинский Помощник',
        shortName: 'Будь Здоров',
        description: 'Интеллектуальный помощник врача для создания медицинских протоколов и документации',
        display: 'standalone',
        startUrl: '/',
        scope: '/',
        orientation: 'portrait',
        backgroundColor: '#F4F8FF',
        themeColor: '#1E6FFF',
        iconsFolder: 'budzdorov',
        updateFavicon: true,
        updateTitle: true,
    },

    // ============================================
    // РЕГИСТРАЦИЯ
    // ============================================
    registration: {
        enabled: false,
    },

    // ============================================
    // ЛОКАЛИЗАЦИЯ
    // ============================================
    i18n: {
        defaultLanguage: 'ru',
        supportedLanguages: ['ru', 'en'],
    },

    // ============================================
    // ДОПОЛНИТЕЛЬНО
    // ============================================
    customSettings: {
        analyticsEnabled: true,
        feedbackEnabled: true,
    },
};